import React, { useEffect } from 'react';
import { MuiBox } from 'theme/material-ui';
import { FontSize, Spacing } from 'modules/styles/variables';
import DefaultText from 'components/UI/Typography/DefaultText';
import Subhead from 'components/UI/Typography/Subhead';
import { FlexBoxColumn, FlexBoxRow } from 'components/UI/Layout/FlexBox';
import Warning from 'assets/warning.png';
import analyticsService, { AmplitudeEventData, AnalyticsEvent } from 'services/AnalyticsService';
import {
  currentLocationPathNameSelector,
  previousLocationPathNameSelector
} from 'store/router/selectors';

import { connect } from 'react-redux';
import { RootState } from 'store/types';
import {
  PreRegistrationFacilitySelector,
  PreRegistrationEncounterInfoSelector
} from 'store/preRegistration/selectors';
import { FacilityLocation } from 'store/preRegistration/types';

interface Props {
  facilityLocation: FacilityLocation | undefined;
  complete: boolean;
  referringUrl: string;
  currentUrl: string;
}

export function ExceptionScreen({ complete, facilityLocation, currentUrl, referringUrl }: Props) {
  useEffect(() => {
    const additionalInfo = complete ? 'Already Completed' : 'Link Expired';
    const amplitudeEventData: AmplitudeEventData = {
      currentUrl,
      referringUrl,
      /* eslint-disable-next-line @typescript-eslint/camelcase */
      form_location: facilityLocation?.name || '',
      /* eslint-disable-next-line @typescript-eslint/camelcase */
      form_detail_additional_info: additionalInfo
    };
    analyticsService.logEvent(AnalyticsEvent.HospitalFormAuthFailed, amplitudeEventData);
  }, []);

  return (
    <FlexBoxColumn
      data-testid="pre-registeration-complete"
      minHeight="100%"
      spacing={Spacing.large}
      flex="1 1 auto"
    >
      <MuiBox mt={15} mb={5}>
        <FlexBoxRow justifyContent="center">
          <img style={{ width: 65, marginBottom: 10 }} src={Warning} alt="warning icon" />
        </FlexBoxRow>
        <MuiBox textAlign="center">
          <DefaultText fontSize={FontSize.heading} fontWeight="bold">
            Link Expired
          </DefaultText>
        </MuiBox>
        <MuiBox p={2} textAlign="center">
          <Subhead>
            We are sorry but this link has expired. If your appointment has been rescheduled, you
            will receive a new link via text message seven days prior to your new appointment date.
          </Subhead>
        </MuiBox>
      </MuiBox>
    </FlexBoxColumn>
  );
}

const mapStateToProps = (state: RootState) => ({
  encounter: PreRegistrationEncounterInfoSelector(state),
  facilityLocation: PreRegistrationFacilitySelector(state),
  currentUrl: currentLocationPathNameSelector(state),
  referringUrl: previousLocationPathNameSelector(state)
});

export default connect(mapStateToProps)(ExceptionScreen);
